import { useState, useEffect } from "react";
import { useQuery, gql } from "@apollo/client";
import { format, parseISO } from 'date-fns';
import { toZonedTime, fromZonedTime } from 'date-fns-tz';
import { Session } from "../../../../../__generated__/graphql";

export const GET_MY_SESSIONS = gql(`
    query GetMySessions{
    mySessions{
      id
      createdAt
  }
}
    `)

function condenseDate(data: string[]): string[] {
    return Array.from(new Set(data))
}
function formatDate(v: string | null | undefined, f = "MM/dd/yyyy") {
    const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    return !v
        ? null
        : v.lastIndexOf('Z') > 0
            ? format(toZonedTime(parseISO(v), timeZone), f)
            : format(fromZonedTime(parseISO(v), ''), f);
}


const useMyLocationSessions = () => {
    const { data, loading } = useQuery(GET_MY_SESSIONS)

    const [sessionDates, setSessionDates] = useState<string[]>([])

    useEffect(() => {
        if (data) {
            const _dates = data?.mySessions.map((session: Session) => formatDate(session.createdAt)) || []
            setSessionDates(condenseDate(_dates))
        }
    }, [data, loading])
    return { sessionDates }
}

export default useMyLocationSessions